// extracted by mini-css-extract-plugin
export default {"countdown":"o_-z","srOnly":"p_-z"};